import data from "../../../../../src/Overlay.docs.json";
import * as React from 'react';
export default {
  data,
  React
};